import { render } from "./ScanViolinComponent.vue?vue&type=template&id=a5b96fb6&scoped=true"
import script from "./ScanViolinComponent.vue?vue&type=script&lang=js"
export * from "./ScanViolinComponent.vue?vue&type=script&lang=js"

import "./ScanViolinComponent.vue?vue&type=style&index=0&id=a5b96fb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b96fb6"]])

export default __exports__